<template>
  <div class="bg-gray-brand-100 h-screen pb-20">
    <!-- navbar -->
    <div class="fixed z-40 w-full top-0">
      <MerchantNav :disable-hide-on-scroll="true" />
    </div>
    <!-- main -->
    <div class="w-full max-w-5xl mx-auto pt-12 h-full">
      <!-- Gift card -->
      <div class="px-2 md:px-0 md:w-1/2 mx-auto mt-14 mb-8">
        <div class="flex justify-start items-center">
          <div class="text-xl font-bold text-gray-brand-900 tracking-tighter ml-3">Gift Card</div>
        </div>
        <div class="mt-4 md:mt-6 bg-white rounded-lg border" :class="cardShadowClasses">
          <div v-if="issuedGiftCard" class="leading-5 pt-4 pb-5 px-6">
            <div class="flex justify-between items-center mb-1">
              <span class="text-md font-semibold text-brand-gray-800">{{ code }}</span>
              <SecondaryButton :size="'sm'" @click="openResendModal">Resend Gift Card</SecondaryButton>
            </div>
            <div class="flex justify-between mt-3 items-center">
              <div class="flex items-center flex-grow">
                <span class="w-8 mr-3 text-gray-500 block">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-6 h-6 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
                    />
                  </svg>
                </span>
                <div class="text-sm font-mono text-gray-brand-900">{{ amount }}</div>
              </div>

              <div class="ml-3 text-sm font-mono text-gray-brand-900">{{ displayPaymentTimestamp }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Gift Card -->
    </div>

    <!-- Success toast -->
    <div
      v-if="showSuccess"
      class="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-50 text-sm font-semibold"
    >
      Gift card email sent successfully
    </div>

    <!-- Resend Modal -->
    <Modal :is-open="showResendModal" @close="closeResendModal">
      <template #title>Resend Gift Card</template>
      <template #body>
        <GiftCardResendForm
          :code="code"
          :initial-email="issuedGiftCard?.attributes?.recipient_email || ''"
          :initial-message="issuedGiftCard?.attributes?.gift_card_message || ''"
          @sent="onResent"
          @cancel="closeResendModal"
        />
      </template>
      <template #footer><span /></template>
    </Modal>
  </div>
</template>
<script>
let strftime = require('strftime')
import { ref } from 'vue'

import { cardShadowClasses } from '@/config'
import { TheBanner, MerchantNav } from '@/components'
import Modal from '@/components/Molecules/Modal'
import SecondaryButton from '@/components/Molecules/SecondaryButton'
import GiftCardResendForm from '@/components/Checkout/GiftCardResendForm'

export default {
  components: { TheBanner, MerchantNav, Modal, SecondaryButton, GiftCardResendForm },
  setup() {},
  data: () => ({
    cardShadowClasses,
    issuedGiftCard: null,
    showResendModal: false,
    showSuccess: false
  }),
  computed: {
    code() {
      return this.$route.params.code
    },
    createdAt() {
      return this.issuedGiftCard?.attributes?.created_at
    },
    amount() {
      return this.issuedGiftCard?.attributes?.gift_card_value?.format
    },
    displayPaymentTimestamp() {
      if (!this.createdAt) return ''
      let day = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      }).format(new Date(this.createdAt))
      return day
    }
  },
  async mounted() {
    window.scrollTo(0, 0)
    this.issuedGiftCard = await this.$store.dispatch('getIssuedGiftCard', this.code)
    this.issuedGiftCard = this.issuedGiftCard?.data
  },
  methods: {
    openResendModal() {
      this.showResendModal = true
    },
    closeResendModal() {
      this.showResendModal = false
    },
    onResent() {
      this.closeResendModal()
      this.showSuccess = true
      setTimeout(() => {
        this.showSuccess = false
      }, 3000)
    }
  }
}
</script>
